




























































































import { Component, Prop, Vue } from "vue-property-decorator";

import { TravelCalculateForm, TravelCalculateResult, TravelIssueForm, TravelIssuePerson } from "@/types/all";

import genders from "@/data/Genders";

import Api from "@/api/travel.api";
import { EventBus, BusEvents } from "@/plugins/event-bus";

@Component
export default class TravelContractForm extends Vue {
  @Prop() data!: TravelCalculateResult;
  @Prop() initialData!: TravelCalculateForm;

  public isLoading: boolean = false;
  public genders: Array<Object> = genders;

  public form: TravelIssueForm = new TravelIssueForm();

  public goBack(): void {
    this.$emit("goBack");
  }

  public issue(): void {
    this.isLoading = true;

    Api.issue(this.form)
      .then((response) => {
        this.$emit("issued", response.data);
      })
      .catch((error) => EventBus.$emit(BusEvents.ERROR, error))
      .finally(() => this.isLoading = false);
  }

  created(): void {
    this.form.startDate = this.initialData.startDate;
    this.form.endDate = this.initialData.endDate;
    this.form.countryId = this.initialData.countryId;
    this.form.currencyId = this.initialData.currencyId;
    this.form.periodId = this.initialData.periodId;
    this.form.amount = this.initialData.amount;
    this.form.purpose = this.initialData.purpose;
    this.form.covidRiskAvailable = this.initialData.covidRiskAvailable;
    this.form.covidCoverage = this.initialData.covidCoverage;

    this.data.insuredPersons.forEach((ip) => {
      let insPerson = new TravelIssuePerson();
      insPerson.identitySerial = "AZE";
      insPerson.birthDate = ip.birthDate;

      this.form.insuredPersons.push(insPerson);
    });
  }
}
